/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Empty1Inputs */

const zh_adminthreads_empty1 = /** @type {(inputs: Adminthreads_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无对话`)
};

const en_adminthreads_empty1 = /** @type {(inputs: Adminthreads_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations`)
};

const es_adminthreads_empty1 = /** @type {(inputs: Adminthreads_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conversaciones`)
};

/**
* | output |
* | --- |
* | "No conversations" |
*
* @param {Adminthreads_Empty1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_empty1 = /** @type {((inputs?: Adminthreads_Empty1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Empty1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_empty1(inputs)
	if (locale === "en") return en_adminthreads_empty1(inputs)
	return es_adminthreads_empty1(inputs)
});
export { adminthreads_empty1 as "adminThreads_empty" }